module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flowchart-object jsplumb-draggable jsplumb-droppable",
    class: _vm.getNodeClass(),
    style: ({
      left: _vm.obj.view.left + "px",
      top: _vm.obj.view.top + "px",
      width: _vm.getWidth() + "px",
      height: _vm.obj.view.h + "px"
    }),
    attrs: {
      "id": _vm.obj.data.id
    }
  }, [(_vm.obj.type === 'outState') ? _c('out-state', {
    attrs: {
      "answer-title": _vm.obj.data.title,
      "remove": _vm.deleteNode
    }
  }) : _vm._e(), _vm._v(" "), (_vm.obj.type === 'inOutState') ? _c('in-out-state', {
    attrs: {
      "answer-title": _vm.obj.data.title,
      "answer-state-question": _vm.obj.data.stateQuestion,
      "answer-state-value": _vm.obj.data.stateValue,
      "answer-words": _vm.obj.data.words,
      "answer-is-illegibly": _vm.obj.data.isIllegibly,
      "answer-is-silence": _vm.obj.data.isSilence,
      "remove": _vm.deleteNode,
      "addWordsForAllByTitle": _vm.addWordsForAllByTitle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.obj.type !== 'inOutState' && _vm.obj.type !== 'outState') ? _c('universal-answer', {
    attrs: {
      "start-node": _vm.obj.startNode,
      "answer-id": _vm.obj.data.id,
      "answer-title": _vm.obj.data.title,
      "answer-state-question": _vm.obj.data.stateQuestion,
      "answer-transkrib-value": _vm.obj.data.useTranscribeByValue,
      "answer-state-value": _vm.obj.data.stateValue,
      "answer-words": _vm.obj.data.words,
      "answer-audio": _vm.obj.data.audio,
      "answer-text": _vm.obj.data.text,
      "answer-generation-type": _vm.obj.data.generationAudioType,
      "answer-is-silence": _vm.obj.data.isSilence,
      "answer-is-illegibly": _vm.obj.data.isIllegibly,
      "answer-search-strategy": _vm.obj.data.searchStrategy,
      "answer-recognition-driver": _vm.obj.data.recognitionDriver,
      "answer-timeout": _vm.obj.data.timeout,
      "answer-start-collect-before-play-end": _vm.obj.data.startCollectBeforePlayEnd,
      "answer-waiting-input-timeout": _vm.obj.data.waitingInputTimeout,
      "answer-silence-after-speech-timeout": _vm.obj.data.silenceAfterSpeechTimeout,
      "answer-delay-before-collect": _vm.obj.data.delayBeforeCollect,
      "answer-current-emotion": _vm.obj.data.emotion,
      "answer-current-vendor": _vm.obj.data.vendor,
      "answer-current-lang": _vm.obj.data.lang,
      "answer-current-speaker": _vm.obj.data.speaker,
      "answer-current-speed": _vm.obj.data.speed,
      "answerGoogleSsmlType": _vm.obj.data.googleSsmlType,
      "answer-repeat": _vm.obj.data.repeat,
      "scenario-id": _vm.obj.scenarioId,
      "remove": _vm.deleteNode,
      "setNodeHeight": _vm.setNodeHeight,
      "setWindowSmall": _vm.setNodeSmall,
      "setWindowMedium": _vm.setNodeMedium,
      "setWindowBig": _vm.setNodeBig,
      "addWordsForAllByTitle": _vm.addWordsForAllByTitle,
      "get-scenario-lang": _vm.getScenarioLang
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "add hidden_for_client_automation"
  }, [(_vm.obj.type === 'inOutState') ? _c('i', {
    staticClass: "fas fa-comment-medical add_answer",
    attrs: {
      "title": _vm.$t('common.actions.add') + ' ' + _vm.$t('scenarios.konstruktor.canvas.add.robotAnswer')
    },
    on: {
      "click": function($event) {
        return _vm.addAnswer()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.obj.type !== 'inOutState') ? _c('i', {
    staticClass: "fas fa-network-wired add_state",
    attrs: {
      "title": _vm.$t('common.actions.add') + ' ' + _vm.$t('scenarios.konstruktor.canvas.add.recognition')
    },
    on: {
      "click": _vm.addInOutState
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fas fa-user-tie add_redirect",
    attrs: {
      "title": _vm.$t('common.actions.add') + ' ' + _vm.$t('scenarios.konstruktor.canvas.add.redirectToOperator')
    },
    on: {
      "click": function($event) {
        return _vm.addRedirect()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fab fa-connectdevelop connect",
    attrs: {
      "title": _vm.$t('common.actions.connect')
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-sms addSms",
    class: _vm.obj.availableSmsGateways && _vm.obj.availableSmsGateways.length ? 'hasSmsGateways' : '',
    attrs: {
      "title": _vm.$t('scenarios.konstruktor.canvas.add.sendSMS')
    },
    on: {
      "click": function($event) {
        return _vm.addSMS(null, null, _vm.obj.availableSmsGateways)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-file-code hidden_for_client addHttpRequest",
    attrs: {
      "title": _vm.$t('scenarios.konstruktor.canvas.add.sendHttpRequest')
    },
    on: {
      "click": function($event) {
        return _vm.addHttpRequest()
      }
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-706346a6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/konstruktor/BaseEditableNode.vue
// module id = 476
// module chunks = 42